import { render, staticRenderFns } from "./AddVedio.vue?vue&type=template&id=485990ac&scoped=true"
import script from "./AddVedio.vue?vue&type=script&lang=js"
export * from "./AddVedio.vue?vue&type=script&lang=js"
import style0 from "./AddVedio.vue?vue&type=style&index=0&id=485990ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485990ac",
  null
  
)

export default component.exports